module.exports = __webpack_public_path__ + "img/framedleScreenshot.a731ed89.png";